import { messageData } from '@VineyardLib/data/message-data';

/**
 * string型への変換
 * @param value 変換する値
 * @returns string型
 */
export function convertToString(value: any): string {
  if (value == null) {
    return '';
  }
  return String(value);
}

/**
 * messageDataへ変換する
 * @param errorMessage 変換する値
 * @returns string→messageData、string[]→messageData[]
 */
export function convertToMessageData(
  errorMessage: string | string[]
): messageData | messageData[] {
  if (errorMessage instanceof Array) {
    return errorMessage.map((error) => {
      return { messageKey: error };
    });
  } else {
    return { messageKey: errorMessage };
  }
}
